<template>
  <v-card flat>
    <contract-upgrade-calculator v-if="false" :preisKombiAbo="690" vertragsEndDatum="2024-12-06"></contract-upgrade-calculator>
    <employee-list></employee-list>
  </v-card>
</template>

<script>
import contractUpgradeCalculator from "@/views/dashboard/contract/utils/contractUpgradeCalculator"
import employeeList from "@/views/dashboard/employee/employeeList"
export default {
  components: {
    contractUpgradeCalculator,
    employeeList,
  },
  data() {
    return {}
  },
  async created() {},
  methods: {},
}
</script>
